// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
// styles
import 'swiper/css';
import './style/style.css'
import "swiper/css/pagination";
// child
import { SliderChild } from './child/child';


export function Slider(props: any) {
    return (
        <>
            {props.sliders ? (
                <>
                    {props.sliders?.map((slider: any, index: number) => (
                        <>
                            {index < 1 ?
                                <SwiperSlide key={slider.id + 'topslider'}>
                                    <SliderChild
                                        title={slider.title}
                                        text={slider.text}
                                        buttonText={slider.button_text}
                                        buttonLink={slider.button_link}
                                        image={slider.image} />
                                </SwiperSlide>
                                :
                                null
                            }
                        </>
                    ))}
                </>
            ) : null}
        </>
    )
}